var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('assistent-template-picker',{attrs:{"is-submitting":_vm.isSubmitting},on:{"select-template":_vm.onSelectTemplate}})}
var staticRenderFns = []

export { render, staticRenderFns }